import { format } from 'date-fns';

const escapeCsvValue = (header, value, intl) => {
  if (header === 'canceled') {
    const formattedCancelledValue = value ? intl.formatMessage({
      id: 'yes',
      defaultMessage: 'Yes',
    }) : intl.formatMessage({
      id: 'no',
      defaultMessage: 'No',
    });
    return `"${formattedCancelledValue}"`;
  }
  return `"${String(value).replace(/"/g, '""')}"`;
};

const headers = [
  'userEmail',
  'userName', 'address', 'apartmentNumber', 'resourceType', 'slot', 'startDate', 'endDate', 'createdAt', 'canceled'];

export const downloadCsv = (intl, rows) => {

  const csv = [
    headers.join(','),
    ...rows.map((row) => headers.map((header) => escapeCsvValue(header, row[header], intl)).join(',')),
  ].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `booking-history-${format(new Date(), 'yyyy-MM')}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
};
